<template>
  <el-aside
    :class="[
      b(),
      { 'is-collapse': collapse, isOverseasVersion },
      'no-animation'
    ]"
    width="auto"
    @transitionend.native="handleTransition"
  >
    <div>
      <el-image
        :class="['cursor-pointer', b('logo')]"
        :src="logo"
        fit="contain"
        alt=""
        @click="$router.push('/')"
      />
      <LeftMenu
        :menus="topMenu"
        :collapse="collapse"
        :class="b('top-menu')"
        @click="onMenuSelect"
      >
        <template
          v-if="collapse && unreadCount > 0"
          #prefix="{ item }"
        >
          <span
            v-if="item.name === 'notice'"
            :class="b('prefix-badge', { over: unreadCount > 99 })"
          >
            {{ unreadCount > 99 ? '99+' : unreadCount }}
          </span>
        </template>
        <template
          v-if="!collapse && unreadCount > 0"
          #title="{ item }"
        >
          <el-row
            v-if="item.name === 'notice'"
            type="flex"
            align="middle"
          >
            <span class="text-ellipsis zk-left-menu-item__title">
              {{ item.title || (item.meta && item.meta.title) }}
            </span>
            <span :class="b('prefix-badge')">
              {{ unreadCount > 99 ? '99+' : unreadCount }}
            </span>
          </el-row>
          <span
            v-else
            class="text-ellipsis zk-left-menu-item__title"
          >
            {{ item.title || (item.meta && item.meta.title) }}
          </span>
        </template>
      </LeftMenu>
      <div :class="b('divider')">
        <el-divider />
      </div>
    </div>
    <el-scrollbar :class="b('scroll')">
      <LeftMenu
        :menus="routers"
        :collapse="collapse"
        :default-opened.sync="defaultOpened"
        @click="onMenuSelect"
        @open="(item) => toggleOpened(item, true)"
        @close="(item) => toggleOpened(item, false)"
      >
        <template #icon="{ item }">
          <span
            v-if="item.meta && item.meta.subProject"
            :class="b('p-icon')"
            :style="{ background: item.meta.bgColor }"
          >{{ item.icon }}</span>
          <em
            v-else
            :class="[item.icon, 'zk-left-menu-item__icon']"
          />
        </template>
        <template #suffix="{ item }">
          <el-tooltip
            v-if="item.name === 'project' && showCreate"
            :content="$t('sys.permission_name.project_create')"
          >
            <el-row
              type="flex"
              align="middle"
              justify="center"
              :class="b('add-p')"
              @mousedown.native.stop
              @click.native.stop="toCreate"
            >
              <em class="zkicon icontianjia_xiao" />
            </el-row>
          </el-tooltip>
          <div
            v-if="item.name === 'more-project' && item.active"
            :class="b('active-menu')"
          />
        </template>
      </LeftMenu>
    </el-scrollbar>
    <div
      v-if="collapse"
      :class="b('divider2')"
    >
      <el-divider />
    </div>
    <el-row
      type="flex"
      align="middle"
      justify="space-between"
      :class="b('footer')"
    >
      <AvatarMenu
        ref="avatarMenu"
        :class="b('avatar')"
      />
      <el-row
        type="flex"
        align="center"
        :class="b('actions')"
      >
        <RobotChatButton
          v-if="showRobotChat"
        />
        <!--<el-tooltip
          :key="`robot-${collapse ? '0' : '1'}`"
          :placement="collapse ? 'right' : 'top'"
        >
         
           <template #content>
            <div :class="b('content')">
              {{ $t('navbar.RobotChatButton') }} (<em v-if="altKey.includes('zkicon')"
                                                      :class="altKey"
              ></em><span v-else>{{ altKey }}</span>+Shift+A)
            </div>
          </template> 
        </el-tooltip>-->
        <el-tooltip
          :key="`invite-${collapse ? '0' : '1'}`"
          :placement="collapse ? 'right' : 'top'"
          :content="$t('project.Invite_Members')"
        >
          <el-row
            type="flex"
            align="middle"
            justify="center"
            :class="b('invite')"
            @click.native="showDialog"
          >
            <em class="zkicon iconyaoqing" />
          </el-row>
        </el-tooltip>
        <el-tooltip
          :key="`help-${collapse ? '0' : '1'}`"
          :placement="collapse ? 'right' : 'top'"
          :content="$t('navbar.helpCenter')"
        >
          <VersionPopover
            ref="helpPopoverRef"
            :value="showVersionPopover"
            :placement-position="placementPosition"
            :width="tooltipWidth"
            :is-overseas-right="isOverseasVersion && collapse"
          >
            <div
              slot="reference"
              :class="b('breathe', { show: showVersionPopover })"
            >
              <HelpMenu
                ref="helpMenu"
                @toggleShow="handleToggleShow"
              />
            </div>
          </VersionPopover>
        </el-tooltip>
        <OverseasGuideTask v-if="isOverseasVersion" />
      </el-row>
    </el-row>

    <LeftDrawer
      v-if="$el"
      :reference="$el"
      :visible="currentDrawerComponent != null"
      :min-width="currentDrawerMinWidth"
      @update:visible="$event === false && hideDrawer()"
      @after-hide="onAfterHide"
      @showDialog="showDialog"
    >
      <component
        :is="currentDrawerComponent"
        :list="pList"
        :default-type="defaultType"
      />
    </LeftDrawer>

    <InviteMemberDialog
      v-if="inviteDialog"
      :show.sync="inviteDialog"
      :show-import-member="showImportMember"
      @close="inviteDialog = false"
    />
    <SmartAssistantMessageGuidePopover
      v-if="noticeMenuEl"
      :show="showSmartAssistantMessageState"
      :reference-el="noticeMenuEl"
      :im-list="imAuthorizedList"
      @update:showSmartAssistantMessageState="
        showSmartAssistantMessageState = $event
      "
    />
    <AsideToggle
      :collapse="collapse"
      :is-overseas-version="isOverseasVersion"
      :transition-end-time="transitionEndTime"
      :show-drawer="!!currentDrawerComponent"
      :aside-top="asideTop"
      @toggleAside="toggleAside"
    />
  </el-aside>
</template>

<script>
import theme from '@zk/theme/lib/variables.scss';
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
import { isNil, keyBy, orderBy, uniq } from 'lodash';
import LeftMenu from './menu/LeftMenu';
import HelpMenu from './HelpMenu';
import AvatarMenu from '@/layouts/components/AvatarMenu';
import InviteMemberDialog from 'common-module/src/components/OrganizeInviteMember';

// import SubscriptionDialog from 'common-module/src/components/Subscription/dialog';
import { resolveUrl, tryToNumber } from '@zk/framework-vue';
import { userHabitQuery, userHabitRecord } from '@/api/user';
import { setHasRead } from '@/api/message';
import { getImAndAuthorized } from '@/api/widget';
import { setCache, setVo } from '@zk/framework-vue';
import { getTrigger, getAction, getContent } from '@/layouts/utils/msgParse';
import { isOverseasVersion } from 'common-module/src/util';
import { changeProject } from '@/utils/changeProjectByNav';
import AsideToggle from './AsideToggle';
import VersionPopover from './menu/PushPopover';
import { imMap } from './help';
import OverseasGuideTask from '@/pages/welcome/__components__/guide-task-center';
import { addResizeListener, removeResizeListener } from 'zk-ui';
import { closeRobotChat } from 'robot-chat';
import RobotChatButton from './RobotChatButton';
import config from 'common-module/src/config';
import { exchangeTicketOfToken } from '@/api/user';
import { getToken } from 'common-module/src/util/auth';
import * as permission from 'common-module/src/config/permission';
import { isPrivateVersion } from 'common-module/src/util';

const MessageNoticeDrawer = () => import('./drawer/MessageNoticeDrawer');
const ProjectListDrawer = () => import('./drawer/ProjectListDrawer');
const SearchDrawer = () => import('./drawer/SearchDrawer');
const LogoDefault1 = require('@/assets/logo.svg');
const LogoDefault2 = require('@/assets/logo-w.png');
export default {
  name: 'LeftAside',
  components: {
    // eslint-disable-next-line
    InviteMemberDialog,
    OverseasGuideTask,
    AvatarMenu,
    HelpMenu,
    SmartAssistantMessageGuidePopover: () => import('./SmartAssistantMessageGuidePopover'),
    LeftDrawer: () => import('./menu/LeftDrawer'),
    LeftMenu,
    AsideToggle,
    VersionPopover,
    RobotChatButton
  },
  bemNS: theme.bemNS,
  inject: ['appLayout'],
  props: {
    collapse: {
      type: Boolean,
      default: false
    },
    microAppName: {
      type: String,
      default: null
    }
  },
  shortcutsEvents() {
    return [
      {
        key: '/',
        type: 'global',
        callback: (e) => {
          if (!this.appLayout.showAside) {
            return;
          }
          // 防止输入框内添加 / ；
          e.preventDefault();
          this.openSearchDrawer();
          this.$track.send(
            'Hotkeys',
            {
              Hotkeys_Scope: '全局',
              Hotkeys_Name: '/',
              Hotkeys_Path: this.$route.path,
              Has_Dialog: true
            },
            true
          );
          this.$track.send('ES_SidebarShow', { Open_Path: '快捷键' }, true);
        }
      },
      {
        key: 'n',
        type: 'global',
        callback: () => {
          if (!this.appLayout.showAside) {
            return;
          }
          this.openNoticeMsgDrawer();
          this.$track.send(
            'Hotkeys',
            {
              Hotkeys_Scope: '全局',
              Hotkeys_Name: 'n',
              Hotkeys_Path: this.$route.path,
              Has_Dialog: false
            },
            true
          );
        }
      }
    ];
  },
  socketEvents: {
    issueUnreadNotice(data) {
      // eslint-disable-next-line
      this.setUnreadInfo(data?.unreads);
    },
    issueAddNotice(data) {
      this.sendIssueNotice(data);
    },
    issueUpdateNotice(data) {
      this.sendIssueNotice(data);
    },
    issueDeleteNotice(data) {
      this.sendIssueNotice(data);
    }
  },
  microEvents: {
    openNoticeMsg(type) {
      if (this.currentDrawerName === 'notice') {
        this.defaultType = type;
        return;
      }
      this.openNoticeMsgDrawer(type);
    },
    updateNavProjectList() {
      // eslint-disable-next-line
      this.quickProjectList = this.filterQuickProjectList(this.pList);
    }
  },
  data() {
    return {
      inviteDialog: false,
      currentDrawer: null,
      noticeMenuEl: null,
      imAuthorizedList: [],
      showSmartAssistantMessageState: false,
      defaultOpened: [],
      defaultType: null,
      quickProjectList: [],
      isOverseasVersion: isOverseasVersion,
      transitionEndTime: 0,
      openPath: '',
      showTooltip: true,
      showImportMember: false,
      asideTop: 0
    };
  },
  computed: {
    ...mapGetters('user', [
      'userId',
      'orgAvatar',
      'orgMiniAvatar',
      'avatar',
      'isAnonymous',
      'checkAccessPermission',
      'checkModuleSupport'
    ]),
    ...mapGetters('app', ['getProjectFirstChar', 'isModelShow', 'versionClosed', 'checkMenuVisible']),
    ...mapGetters('features', ['isSwitch']),
    ...mapGetters('msgNotice', ['unreadCount']),
    ...mapState('app', ['projectList', 'currentProject', 'isGuiding']),
    ...mapState('user', ['asideCollapse', 'account', 'asideBeforeProjectChangeCb']),
    showCreate() {
      return this.checkAccessPermission(permission.projectCreate);
    },
    showVersionPopover() {
      return !this.versionClosed && this.showTooltip && this.isModelShow;
    },
    userName() {
      return this.account?.userName || '';
    },
    placementPosition() {
      return this.collapse ? 'right' : 'top-end';
    },
    tooltipWidth() {
      return this.collapse ? 296 : 240;
    },
    // eslint-disable-next-line
    pList() {
      return this.projectList
        .filter((item) => item.archived !== 1)
        .map((item) => ({
          ...item,
          icon: this.getProjectFirstChar(item.pname)
        }));
    },
    limitProjectList() {
      if (!this.quickProjectList.length) {
        return [];
      }
      const list = orderBy(
        this.quickProjectList,
        [
          (item) => item.sinkNodeEntity === 'Favorite'
            ? 3
            : item.recentVisit === 1
              ? 2
              : 1
        ],
        ['desc']
      ).slice(0, 3);
      if (list.length < 3) {
        // eslint-disable-next-line
        for (const item of this.pList) {
          if (list.some((p) => p.id === item.id)) {
            continue;
          }
          list.push(item);
          if (list.length >= 3) {
            break;
          }
        }
      }
      return list;
    },
    projectMenu() {
      return this.limitProjectList.map((item) => ({
        ...item,
        name: `${item.id}`,
        icon: item.icon,
        meta: {
          title: item.pname,
          bgColor: item.backgroundColor,
          subProject: true
        },
        selected: this.currentProject === item.id && this.isProjectPage,
        onSelected: async (p) => {
          const isToKanbanPage = !this.isProjectPage || this.$route.name === 'project-list';
          await changeProject({
            id: p.id,
            trackInfo: {
              id: p.id,
              pname: p.pname,
              eventGroupCode: p.sinkNodeEntity === 'Favorite'
                ? 'favorite'
                : p.recentVisit === 1
                  ? 'latest'
                  : 'list'
            }
          }, isToKanbanPage);
        }
      }));
    },
    isProjectPage() {
      if (isOverseasVersion) {
        return !!this.microAppName && this.$route.name !== 'project-list';
      }
      return !!this.microAppName;
    },
    /**
     * 当前访问页面属于项目二级菜单的页面：kanban、backlog等，且以下两种任意一种情况都会为active状态
     * 项目为折叠状态
     * 当前访问的项目不是快捷项目中的
     * @returns {*|boolean}
     */
    activeProjectMenu() {
      if (isOverseasVersion) {
        if (this.$route.name === 'project-list') {
          return true;
        }
        return (
          this.isProjectPage &&
        (
          this.projectMenu.some((item) => item.selected))
        ) && !this.defaultOpened.includes('project');
      }
      return (
        this.isProjectPage &&
        (!this.defaultOpened.includes('project') ||
          !this.projectMenu.some((item) => item.selected))
      );
    },
    activeMoreProject() {
      return this.currentDrawer?.name === 'more-project';
    },
    currentDrawerComponent() {
      return this.currentDrawer?.component;
    },
    currentDrawerMinWidth() {
      return this.currentDrawer?.minWidth || '150px';
    },
    currentDrawerName() {
      return this.currentDrawer?.name;
    },
    projectMenus() {
      if (this.projectMenu.length) {
        return [
          ...this.projectMenu,
          {
            name: 'more-project',
            icon: 'zkicon iconmore',
            meta: {
              title: this.$t('navbar.moreProject')
            },
            active: this.activeMoreProject,
            drawer: true,
            onSelected: (item) => {
              this.changeCurrentDrawer({
                component: ProjectListDrawer,
                name: item.name,
                minWidth: '430px'
              });
            }
          }
        ];
      }
      return [];
    },
    routers() {
      return [
        {
          name: 'dashboard',
          icon: 'zkicon iconxiangmugailan',
          hotKey: ['G', 'D'],
          toolTip: this.$t('navbar.hotkeys.enterHome'),
          collapseShowTip: true,
          selected: this.$route.name === 'dashboard',
          meta: {
            title: this.$t('navbar.Home')
          },
          params: {
            from: 'menu'
          },
          show: this.checkMenuVisible('dashboard')
        },
        {
          name: 'project',
          icon: 'zkicon iconkongjian',
          hotKey: ['G', 'P'],
          collapseShowTip: true,
          toolTip: this.$t('navbar.hotkeys.enterLastVisitedProject'),
          meta: {
            title: this.$t('navbar.project')
          },
          selected: this.activeProjectMenu,
          children: this.projectMenus,
          onSelected: () => {
            this.$router.push('/project/list');
          },
          show: true
        },
        {
          name: 'team',
          icon: 'zkicon iconrenyuan',
          hotKey: ['G', 'T'],
          collapseShowTip: true,
          toolTip: this.$t('navbar.hotkeys.enterTeam'),
          selected: this.$route.name === 'team',
          meta: {
            title: this.$t('navbar.teams'),
            ...permission.teamPage
          },
          show: this.checkMenuVisible('team')
        },
        {
          name: 'roadmap',
          icon: 'zkicon icongantetu',
          hotKey: ['G', 'M'],
          collapseShowTip: true,
          toolTip: this.$t('navbar.hotkeys.enterRoadmap'),
          selected: this.$route.name === 'roadmap',
          meta: {
            title: this.$t('navbar.roadmap'),
            ...permission.roadmapPage
          },
          show: this.checkMenuVisible('roadmap')
        },
        {
          name: 'release',
          icon: 'zkicon iconbanben',
          hotKey: ['G', 'R'],
          collapseShowTip: true,
          toolTip: this.$t('navbar.hotkeys.enterReleaseTips'),
          selected:
            this.$route.name === 'release' ||
            this.$route.name === 'release-detail',
          meta: {
            title: this.$t('navbar.release'),
            ...permission.integrationReleaseView
          },
          onSelected: () => {
            const routePath = '/release';
            this.$router.push(routePath);
            this.$track.send('Release_Visit', {}, true);
          },
          show: this.checkMenuVisible('version')
        },
        {
          name: 'document',
          icon: 'zkicon iconwendang2',
          // hotKey: ['G', 'D'],
          collapseShowTip: true,
          toolTip: this.$t('navbar.document'),
          meta: {
            title: this.$t('navbar.document'),
            ...permission.documentPage
          },
          selected: this.$route.name === 'document',
          onSelected: async () => {
            let documentDomain = config.VUE_APP_DOCUMENT_SITE_DOMAIN || location.host.replace(/(\w+)/, '$1-docs');
            if (location.hostname === 'localhost') {
              documentDomain = 'localhost:3000';
            }
            const token = getToken() || this.$store.state.user?.token;
            const ticket = await exchangeTicketOfToken(token);
            window.open(`${location.protocol}//${documentDomain}/overview?ticket=${ticket}`);
            this.$track.send('Click_Docs', {}, true);
          },
          // eslint-disable-next-line
          show: isOverseasVersion && this.account?.features['doc_switch']
        },
        {
          name: 'support-center',
          icon: 'zkicon iconkefu',
          meta: {
            title: this.$t('navbar.supportCenter'),
            ...permission.supportCenterPage
          },
          show: true,
          onSelected: () => {
            this.$router.push('/support-center/tickets');
          },
          children: [
            {
              name: 'support-center-tickets',
              meta: {
                title: this.$t('navbar.supportCenter.tickets'),
                ...permission.supportCenterTicketsPage
              },
              selected: this.$route.name === 'support-center-tickets',
              onSelected: () => {
                this.$router.push('/support-center/tickets');
              }
            },
            {
              name: 'support-center-requesters',
              meta: {
                title: this.$t('navbar.supportCenter.requesters'),
                ...permission.supportCenterRequestersPage
              },
              selected: this.$route.name === 'support-center-requesters',
              onSelected: () => {
                this.$router.push('/support-center/requesters');
              }
            },
            {
              name: 'support-center-email-config',
              meta: {
                title: this.$t('navbar.supportCenter.emailConfig'),
                ...permission.supportCenterEmailConfigPage
              },
              selected: this.$route.name === 'support-center-email-config',
              onSelected: () => {
                this.$router.push('/support-center/email-config');
              }
            }
          ]
        }
      ].map((item) => {
        if (item.children?.length) {
          return {
            ...item,
            children: item.children.filter((child) => this.checkAccessPermission(child.meta))
          };
        }
        return item;
      }).filter((item) => {
        if (!item.show) {
          return false;
        }
        if (this.checkAccessPermission(item.meta)) {
          return true;
        }
        if (item.children?.length) {
          return item.children.some((child) => this.checkAccessPermission(child.meta));
        }
        return false;
      });
    },
    logo() {
      if (this.collapse) {
        return this.orgMiniAvatar || LogoDefault1;
      }
      return this.orgAvatar || LogoDefault2;
    },
    topMenu() {
      return [
        {
          name: 'notice',
          icon: 'zkicon iconbells',
          hotKey: ['N'],
          toolTip: this.$t('navbar.hotkeys.enterIssue'),
          collapseShowTip: true,
          meta: {
            title: this.$t('message.message_title')
          },
          selected: this.$route.name === 'message-setting',
          active:
            this.currentDrawer?.name === 'notice' ||
            this.$route.name === 'message-setting',
          drawer: true,
          onSelected: () => {
            this.openNoticeMsgDrawer();
          }
        },
        {
          name: 'search',
          icon: 'zkicon iconsousuo1',
          hotKey: ['/'],
          toolTip: this.$t('navbar.hotkeys.globalSearch'),
          collapseShowTip: true,
          meta: {
            title: this.$t('navbar.Search_global')
          },
          active: this.currentDrawer?.name === 'search',
          drawer: true,
          onSelected: () => {
            this.openSearchDrawer();
            this.$track.send('ES_SidebarShow', { Open_Path: '点击菜单' }, true);
          }
        }
      ];
    },
    currentRoles() {
      return this.$store.getters.allRoles || [];
    },
    showRobotChat() {
      return this.isSwitch('user:lark_ai_chat_switch');
    },
    altKey() {
      const isMac = /macintosh|mac os x/i.test(navigator.userAgent);
      return isMac ? 'zkicon iconoption' : 'Alt';
    }
  },
  watch: {
    // eslint-disable-next-line
    pList(value) {
      this.updateQuickProject(value);
    },
    collapse() {
      this.resetPosition();
    }
  },
  created() {
    // eslint-disable-next-line
    this.quickProjectList = this.filterQuickProjectList(this.pList);
    if (this.$route.meta.share !== true && !this.isAnonymous) {
      this.queryCollapseHabit();
      this.queryProjectExpandHabit();
      this.initMenuExpandByRoute();
      this.refreshUnreadInfo();
    }
  },
  mounted() {
    addResizeListener(this.$el, this.handleResize);
    if (typeof window.Notification !== 'undefined') {
      Notification.requestPermission();
    }
    this.eventBus.$on('open-project-menu', this.openProjectMenu);
    this.eventBus.$on('open-search-drawer', this.openSearchDrawer);
    this.eventBus.$on('open-msg-drawer', this.openNoticeMsgDrawer);
    this.eventBus.$on('hide-drawer', this.hideDrawer);
  },
  beforeDestroy() {
    removeResizeListener(this.$el, this.handleResize);
    this.eventBus.$off('open-project-menu', this.openProjectMenu);
    this.eventBus.$off('open-search-drawer', this.openSearchDrawer);
    this.eventBus.$off('hide-drawer', this.hideDrawer);
    this.eventBus.$off('open-msg-drawer', this.openNoticeMsgDrawer);
  },
  methods: {
    ...mapMutations('msgNotice', ['setUnreadInfo']),
    ...mapActions('app', ['changeProject']),
    ...mapActions('msgNotice', ['refreshUnreadInfo']),
    handleResize(){
      this.asideTop = this.$el.getBoundingClientRect()?.top || 0;
    },
    handleToggleShow(value) {
      this.showTooltip = value;
    },
    resetPosition() {
      const update = (startTime) => {
        const currentTime = Date.now();

        // ... do work
        this.$refs.helpPopoverRef?.$refs.PopoverRef?.updatePopper();

        if (currentTime - startTime <= 2000) {
          // 执行时间小于设定值
          requestAnimationFrame(() => update(startTime));
        }
      };
      update(Date.now());
      const robot = document.querySelector('.robot-chat');
      if (robot) {
        robot.style.setProperty('--leftPosition', this.collapse ? '58px' : '258px');
      }
    },
    handleTransition(e) {
      if (e.target === this.$el && e.propertyName === 'width') {
        this.transitionEndTime = +new Date();
      }
    },
    filterQuickProjectList(list) {
      return list.filter(
        (item) => item.sinkNodeEntity === 'Favorite' || item.recentVisit === 1
      );
    },
    updateQuickProject(list) {
      const pMap = keyBy(list, 'id');
      this.quickProjectList.forEach((p) => {
        if (pMap[p.id]) {
          setVo(p, pMap[p.id]);
        }
      });
    },
    toggleAside(collapse) {
      const value = isNil(collapse) ? !this.asideCollapse : collapse;
      this.setCollapseHabit(value);
      setCache('left-nav-collapse', value, { version: 'none' });
      this.$emit('update:collapse', value);
    },
    flashPendingDrawer() {
      this.currentDrawer = this.pendingDrawer;
      this.oldDrawer = { ...this.pendingDrawer };
      this.pendingDrawer = null;
    },
    onAfterHide() {
      if (this.oldDrawer?.name === 'notice') {
        setTimeout(() => this.showSmartAssistantMessagePopover(), 1000);
      }
      this.flashPendingDrawer();
    },
    addDrawerClassToBody() {
      document.body.classList.add('left-drawer-open');
    },
    removeDrawerClassToBody() {
      document.body.classList.remove('left-drawer-open');
    },
    async changeCurrentDrawer(item) {
      this.addDrawerClassToBody();
      if (item.name === this.currentDrawerName) {
        this.hideDrawer();
        return;
      }

      this.pendingDrawer = item;
      if (!this.currentDrawer) {
        this.flashPendingDrawer();
        return;
      }
      this.hideDrawer();
    },
    hideDrawer() {
      this.removeDrawerClassToBody();
      this.currentDrawer = null;
    },
    openNoticeMsgDrawer(type) {
      this.defaultType = type;
      this.changeCurrentDrawer({
        component: MessageNoticeDrawer,
        name: 'notice',
        minWidth: '500px'
      });
    },
    openSearchDrawer() {
      this.changeCurrentDrawer({
        component: SearchDrawer,
        name: 'search',
        minWidth: '530px'
      });
    },
    onMenuSelect(item, e) {
      e.stopPropagation();
      this.$refs.avatarMenu.hide();
      this.$refs.helpMenu.hide();
      this.closeChat();
      this.eventBus.$emit('leftAside:click');
      if (!item.drawer) {
        this.hideDrawer();
      }
      if (typeof item.onSelected === 'function') {
        Reflect.apply(item.onSelected, this, [item]);
        return;
      }

      if (this.isGuiding) {
        this.$router.push({
          ...item,
          query: {
            ...(item.query || {}),
            guide: true
          }
        });
      } else {
        this.$router.push({
          ...item,
          query: item.query || {}
        });
      }
    },
    async queryCollapseHabit() {
      const res = await userHabitQuery({
        linkType: 'leftSwitchCollapse',
        projectId: 0,
        userId: this.userId
      });
      if (res && res.result.linkIdList?.length) {
        const collapse = JSON.parse(res.result.linkIdList[0]) || false;
        this.$emit('update:collapse', collapse === 1);
      }
    },
    setProjectExpandHabit(value) {
      return userHabitRecord({
        linkIdList: [`${value}`],
        linkType: 'foldProjectView',
        projectId: 0,
        userId: this.userId
      });
    },
    openProjectMenu() {
      if (this.defaultOpened.includes('project')) {
        return;
      }
      this.defaultOpened.push('project');
      this.setProjectExpandHabit(true);
    },
    async queryProjectExpandHabit() {
      const res = await userHabitQuery({
        linkType: 'foldProjectView',
        projectId: 0,
        userId: this.userId
      });
      if (res && res.result.linkIdList?.length) {
        const expand = JSON.parse(res.result.linkIdList[0]) || false;
        if (expand) {
          this.defaultOpened = ['project'];
        }
      }
      this.initMenuExpandByRoute(); 
    },
    initMenuExpandByRoute() {
      const supportCenterRoutes = [
        'support-center-tickets',
        'support-center-requesters',
        'support-center-email-config'
      ];
      if (supportCenterRoutes.includes(this.$route.name)) {
        if (!this.defaultOpened.includes('support-center')) {
          this.defaultOpened = [...this.defaultOpened, 'support-center'];
        }
      }
    },
    toggleOpened(item, opened) {
      if (item.name === 'project') {
        this.setProjectExpandHabit(opened);
      }
    },
    setCollapseHabit(value) {
      return userHabitRecord({
        linkIdList: [value ? 1 : 0],
        linkType: 'leftSwitchCollapse',
        projectId: 0,
        userId: this.userId
      });
    },
    setUserMessageSmartAssistantHabit() {
      return userHabitRecord({
        linkIdList: [1],
        linkType: 'userMessageSmartAssistantConfig',
        projectId: 0,
        userId: this.userId
      });
    },
    async queryUserHabit(type) {
      const r = await userHabitQuery({
        linkType: type,
        projectId: 0,
        userId: this.userId
      });
      return r.result;
    },
    async showSmartAssistantMessagePopover() {
      const modal = document.querySelector('.v-modal');
      if (modal) {
        return;
      }
      const recordVisible = await this.queryUserHabit(
        'userMessageSmartAssistantConfig'
      );
      if (recordVisible.linkIdList.length) {
        return;
      }
      const imList = await getImAndAuthorized();

      const l = imList.filter((i) => i.authorized).map((i) => i.imType);
      const c = uniq(this.currentRoles.map((i) => i.roleCode));
      if (imList.some((i) => i.authorized)) {
        this.$track.send(
          'Show_IMNotification_Guide',
          {
            Current_Role: c,
            Authorize_And_Name: l,
            Has_IM_Permissions: l.filter((im) => this.checkAccessPermission(imMap[im])
            )
          },
          true
        );
        return;
      }

      this.imAuthorizedList = imList;

      this.$track.send(
        'Show_IMNotification_Guide',
        {
          Current_Role: c,
          Authorize_And_Name: l,
          Has_IM_Permissions: l.filter((im) => this.checkAccessPermission(imMap[im]))
        },
        true
      );

      this.setUserMessageSmartAssistantHabit();
      //海外版并且是私有化，则屏蔽引导
      if (isOverseasVersion && isPrivateVersion) {
        this.noticeMenuEl = false;
      } else {
        this.noticeMenuEl = this.$el.querySelector('.zk-left-menu-item[data-menu=notice]');
      }
      setTimeout(() => {
        this.showSmartAssistantMessageState = true;
      }, 60);
    },
    toCreate() {
      this.eventBus.$emit('tool:action', 'project.create', {
        source: '导航栏'
      });
    },
    sendIssueNotice(data) {
      if (
        typeof window.Notification === 'undefined' ||
        Notification.permission !== 'granted'
      ) {
        return;
      }
      const triggerName = getTrigger(data);
      const action = getAction(data, this.$i18n);
      const content = getContent(data, false) || data.subject;
      const body = `${triggerName ? `${triggerName} ` : ''}${
        action ? `${action} ` : ''
      }${content}`;
      const notice = new Notification(data.subject, { body });
      notice.onclick = async () => {
        notice.close();
        window.focus();
        let commentId = null;
        if (data.content === 'comment') {
          commentId = JSON.parse(data.extend);
        } else if (data.content === 'commentReply') {
          commentId = JSON.parse(data.extend).commentId;
        }
        if (data.code === 'epic') {
          window.open(
            resolveUrl(
              // eslint-disable-next-line
              `${this.$config.VUE_APP_PMS_URL}/epic/list?pid=${data.projectId}&epicid=${data.msgId}&commentId=${commentId}`
            ),
            '_blank'
          );
        } else if (data.msgTypeName === 'Issue.i_issue') {
          let id = data.msgId;
          if (data.code === 'subtask') {
            id = tryToNumber(data.extend);
            id = isNaN ? data.msgId : id;
          }
          this.eventBus.$emit('issue:edit', { id, commentId, source: '消息通知' });
        }

        const unreadInfo = await setHasRead({ id: data.reminderReceiveId });
        this.setUnreadInfo(unreadInfo);
      };
    },
    showDialog() {
      this.inviteDialog = true;
      this.showImportMember = false;
    },
    eventInviteDialog(showImportMember = true) {
      this.showImportMember = showImportMember;
      this.inviteDialog = true;
    },
    // openChat() {
    //   this.$refs.avatarMenu.hide();
    //   this.$refs.helpMenu.hide();
    //   this?.hideDrawer();
    // },
    closeChat() {
      closeRobotChat(true);
    }
  }
};
</script>

<style lang="scss">
$menuBg: #33344b;
$defaultColor: #b7b6cd;
$activeColor: #fff;

@include b(left-aside) {
  user-select: none;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: var(--p-larger) 0;
  padding-bottom: 10px;
  background: $menuBg;
  overflow: visible !important;
  width: 258px !important;
  transition: width 0.28s;
  .el-divider {
    margin:0 12px;
    width: calc(100% - 24px);
    background: #575872;
  }
  @include e(divider){
    margin-bottom: 2px;
    margin-top: 12px;
  }
  @include e(divider2){
    margin-top: 2px;
    margin-bottom: 18px;
  }

  .zk-left-menu:not(.is-collapse) {
    .zk-left-menu-item__content {
      &:hover {
        @include e(add-p) {
          display: flex !important;
        }
      }
    }
  }
  &.is-collapse {
    .zk-robot-chat-button {
      padding-bottom: 10px;
      display: flex;
    }
    @include e(avatar){
      height: 42px;
    }
    @include e(breathe){
      padding: 0;
      width: 36px;
      height: 36px;
    }
  }
  @include e(actions) {
    justify-content: center;
    align-items: center;
  }
  &.isOverseasVersion {
    @include when(collapse) {
      width: 0px !important;
      overflow: hidden !important;
    }
  }
  @include when(collapse) {
    width: 58px !important;
    .zk-help-menu__ref {
      margin-left: 0;
    }
    @include e(logo) {
      width: 50px;
      margin-left: 4px;
    }
    @include e(prefix-badge) {
      position: absolute;
      left: 32px;
      top: -3px;
      z-index: 1;
      margin-left: 0;
      font-family: 'Helvetica Neue';
      @include m(over) {
        left: 24px;
      }
    }
    @include e(p-icon) {
      margin-right: 0;
    }
    @include e(actions) {
      flex-wrap: wrap;
      order: 1;
      margin-bottom: 14px;
      justify-content: center;
    }
    @include e(footer) {
      flex-direction: column;
      margin: auto;
      & > span:first-child {
        order: 2;
      }
    }
  }

  @include e(logo) {
    width: 108px;
    height: 34px;
    background: $menuBg;
    margin-left: 28px;
    margin-bottom: 20px;
    transition: width 0.28s;
    .el-image__placeholder {
      background: $menuBg;
    }
  }
  @keyframes scaleBoxShadow {
    0% {
      box-shadow: 0 0 0 6px rgba(99, 96, 230, 0.2);
    }
    25% {
      box-shadow: 0 0 0 2px rgba(99, 96, 230, 1);
    }
    50% {
      box-shadow: 0 0 0 6px rgba(99, 96, 230, 0.2);
    }
    75% {
      box-shadow: 0 0 0 2px rgba(99, 96, 230, 1);
    }
    100% {
      box-shadow: 0 0 0 6px rgba(99, 96, 230, 0.2);
    }
  }
  @include e(breathe) {
    padding: 6px;
    width: 48px;
    height: 48px;
    border-radius: 6px;
    @include m(show) {
      // border: 1px solid var(--primary-color);
      // animation: 3s infinite linear scaleBoxShadow;
    }
  }
  @include e(prefix-badge) {
    height: 18px;
    border-radius: 24px;
    padding: 0 5px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background: #e02020;
    font-size: 12px;
    transform: scale(0.9);
    color: #ffffff;
    margin-left: 4px;
  }

  @include e(divider) {
    position: relative;
  }

  @include e(scroll) {
    flex: 1;
    .el-scrollbar__view {
      padding-top: 10px;
    }
    .el-scrollbar__wrap {
      overflow-x: hidden;
    }
  }

  @include e(footer) {
    margin: 20px 12px 0 20px;
    .el-avatar {
      flex-shrink: 0;
    }
    .zk-help-menu__ref {
      margin-left: 0px;
    }
    @include icon {
      font-size: 20px;
      line-height: 1;
      color: #cfcde0;
    }
  }
  @include e(invite upgrade) {
    display: inline-flex;
    width: 36px;
    height: 36px;
    border-radius: 14px;
    cursor: pointer;

    &:hover {
      background: rgba(#b7b6cd, 0.12);
    }
  }
  @include e(p-icon) {
    width: 18px;
    height: 18px;
    line-height: 18px;
    text-align: center;
    border-radius: 2px;
    margin-right: 8px;
    font-size: var(--size-font-9);
    color: #ffffff;
    flex-shrink: 0;
  }
  @include e(add-p) {
    width: 18px;
    height: 18px;
    border-radius: var(--radius-mini);
    margin-right: 16px;
    display: none !important;
    &:hover {
      background-color: #73728d;
    }
    @include icon {
      font-size: 18px;
    }
  }
  @include e(content) {
    display: flex;
    align-items: center;
  }
}
</style>
